// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1BHLL","loader__holder":"Loader_loader__holder__6N-YT","global-loading":"Loader_global-loading__3CBZp"};